import withStyles, { CSSProperties } from '@material-ui/core/styles/withStyles'
import GlobalStyles from 'global.styles.copy'
import { Theme } from '@material-ui/core/styles/createMuiTheme'

export function withGlobalStyles(...styles: Array<any>) {
  return withStyles(
    combineStyles(GlobalStyles, ...styles),
    { withTheme: true },
  )
}

function combineStyles(...styles: Array<any>) {
  return function CombineStyles(theme: Theme) {
    const outStyles = styles.map((arg) => {
      // Apply the "theme" object for style functions.
      if (typeof arg === 'function') {
        return arg(theme)
      }
      // Objects need no change.
      return arg
    })

    return outStyles.reduce((acc, val) => Object.assign(acc, val))
  }
}
